<template>
    <div>
        <b-modal id="m-input-barang-masuk-external" title="Input Barang Masuk External" size="xl" no-close-on-backdrop
            no-close-on-esc hide-footer @show="init()">
            <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
            <div v-else>
                <b-row class="mt-3">
                    <b-col md="6">
                        <div>
                            <div class="font-weight-bold">Jenis Barang</div>
                            <div id="jenis-barang">
                                <multiselect v-model="kindId" :allow-empty="false" label="name" track-by="id"
                                    :internal-search="true" @input="fetchMerkBarang" placeholder="-- Pilih Salah Satu --"
                                    :options="kinds" />
                            </div>
                        </div>
                    <div>
                        <div class="font-weight-bold mt-3">Merk Barang</div>
                        <div id="merk-barang">
                            <multiselect :disabled="fetch || !kindId" v-model="brandId" :allow-empty="false" label="name"
                                track-by="id" :internal-search="true" @input="fetchTipeBarang"
                                placeholder="-- Pilih Salah Satu --" :options="brands" />
                        </div>
                    </div>
                          <div>
                              <div class="font-weight-bold mt-3">Tipe Barang</div>
                              <div id="tipe-barang">
                                  <multiselect :disabled="fetch || !brandId" v-model="typeId" :allow-empty="false" label="name"
                                      track-by="id" :internal-search="true" @input="fetchTahunBarang"
                                      placeholder="-- Pilih Salah Satu --" :options="types" />
                              </div>
                          </div>
                        <div v-if="hasYear">
                            <div class="font-weight-bold mt-3">Tahun / Generasi Barang</div>
                            <div id="tahun-barang">
                                <multiselect :disabled="fetch || !typeId" v-model="yearId" :allow-empty="false"
                                    label="year" track-by="id" :internal-search="true" placeholder="-- Pilih Salah Satu --"
                                    :options="years" />
                            </div>
                            <!-- <b-form-select :disabled="fetch || !typeId" v-model="yearId" text-field="year" value-field="id"
                        :options="years" /> -->
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">Description</div>
                            <b-form-textarea id="description" v-model="input.description" />
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div>
                            <div class="font-weight-bold">No. Faktur Original</div>
                            <b-input id="no-faktur-original" v-model="input.noFakturOriginal" />
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">IMEI / SN</div>
                            <b-input id="imei-sn" v-model="input.imeiSn" />
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">Password</div>
                            <b-input id="password" v-model="input.password" />
                        </div>
                    </b-col>
                </b-row>
                <hr>
                <h5 v-if="!isGold">Input Data Barang</h5>
                <b-row class="mt-3">
                    <b-col md="3">
                        <b-form-group label="Grade Barang">
                            <b-form-select id="grade-barang" v-model="input.grade" :options="optGrade" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Kelengkapan Barang">
                            <b-form-select id="kelengkapan-barang" v-model="input.isBatangan" :options="optBatangan" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Spek Barang">
                            <b-form-select id="spek-barang" v-model="input.spec" :options="optSpec" text-field="name" value-field="id" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Warna Barang">
                            <b-form-select id="warna-barang" v-model="input.color" :options="optColor" text-field="name"
                                value-field="id" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Modal">
                            <b-input-group prepend="Rp.">
                                <b-form-input id="modal" v-model="input.capital" maxlength="50"
                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                    @input="sanitizeCapital" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col md="3">
                        <b-form-group label="Harga di Gadai">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.priceAtPawn" maxlength="50"
                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                    @input="sanitizePriceAtPawn" />
                            </b-input-group>
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <b-row v-if="input.grade == 'X'">
                    <b-col md="12">
                        <b-form-group :label="'Penyesuaian Harga Grade ' + input.grade"
                            description="Gunakan tanda negatif didepan untuk pengurangan harga (Bila positif, maka dianggap penambahan harga)">
                            <b-input-group prepend="Rp.">
                                <b-input id="penyesuaian-harga-grade" v-model="input.adjGrade" @input="sanitizeAdjGrade" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col md="6">
                        <b-form-group label="Accessories yang Tidak Ada">
                            <multiselect :disabled="fetch || !kindId" v-model="input.missingAcc" :multiple="true"
                                label="name" track-by="id" :internal-search="true" deselect-label="" select-label=""
                                :options="optAccessories" :close-on-select="false" />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Accessories yang Tidak Ori">
                            <multiselect :disabled="fetch || !kindId" v-model="input.nonOriAcc" :multiple="true"
                                label="name" track-by="id" :internal-search="true" deselect-label="" select-label=""
                                :options="optAccessories" :close-on-select="false" />
                        </b-form-group>
                    </b-col>
                </b-row> -->

                <!-- ? hide this for now, enhance adjustment calculation -->
                <b-col md="12" class="mb-4" style="display: none;">
                    <b-table id="adjustments-table" bordered hover show-empty no-local-sorting :items="adjustments" :fields="fieldsAdjust"
                        responsive class="mt-4 mb-1">
                        <template v-slot:empty>
                            Tidak ada adjustment.
                        </template>

                        <template v-slot:cell(category)="row">
                            {{ row.item.category }}
                            <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                            <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                            <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                            <!-- <b-form-select v-model="row.item.category" :options="optCategory" @change="onChangeRowCategory(row.index)"
                                :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)"/> -->

                        </template>

                        <template v-slot:cell(name)="row">
                            <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                            <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                            <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                            <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments" @change="changeAdjustment" :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)"/>
                                <small class="text-muted" v-if="row.item.adjustmentSelect === null || row.item.adjustmentSelect.id == null">{{row.item.name_placeholder}}</small> -->
                            {{ row.item.name }}
                        </template>

                        <template v-slot:cell(adjustment)="row">
                            <b-input-group prepend="Rp.">
                                <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" disabled></b-form-input> -->
                                <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" :disabled="(row.item.adjustmentPercentage != '' && row.item.adjustmentPercentage != null) || activeItem.status == '3'" ></b-form-input> -->
                                <b-form-input id="adjustment-input" v-model="row.item.adjustment" @input="sanitize(row.item)"
                                    disabled></b-form-input>
                            </b-input-group>
                        </template>

                        <template v-slot:cell(adjustmentPercent)="row">
                            <b-input-group append="%">
                                <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                <!-- <b-form-input v-model="row.item.adjustmentPercentage" disabled></b-form-input> -->
                                <!-- <b-form-input v-model="row.item.adjustmentPercentage" @input="changeAdjustment" :disabled="(row.item.adjustment != '' && row.item.adjustment != null) || activeItem.status == '3'"></b-form-input> -->
                                <b-form-input id="adjustment-percentage-input" v-model="row.item.adjustmentPercentage"
                                    disabled></b-form-input>
                            </b-input-group>
                        </template>

                        <template v-slot:cell(action)="row">
                            <div class="d-flex">
                                <b-button id="delete-row" variant="danger" size="sm" class="ml-2" v-b-tooltip.hover.top title="Hapus"
                                    @click="deleteRow(row.index)">
                                    <i class="fa fa-fw fa-times" />
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                    <span class="text-muted small mt-1">Biarkan tabel kosong apabila tidak ada adjustment harga</span>
                </b-col>

                <b-row>
                    <b-col md="12">
                        <div style="display:flex; justify-content: end;">
                            <!-- ? hide this for now, enhance adjustment calculation -->
                            <!-- <b-button id="submit-barang" variant="dark" :disabled="isSubmitting || !typeId" @click="openModalAdjustment">
                                Tambah Adjustment
                            </b-button> -->
                            <b-button id="submit-barang" variant="success" :disabled="isSubmitting" @click="promptSubmit">
                                {{ isSubmitting ? "Menyimpan..." : "Submit Barang" }}
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe id="barcode-iframe" :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button id="finish-approval" variant="primary" @click="finishApproval">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-add-adjustment" title="Tambah Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Kategori Kerusakan">
                <b-form-select v-model="addAdj.category" :options="optCategory" @input="onChangeAdjCategory" />
            </b-form-group>
            <b-form-group label="Keterangan">
                  <b-form-select
                    v-model="addAdj.name"
                    :options="addAdj.optAdjustments"
                    :disabled="$helper.isBlank(addAdj.category) || addAdj.optAdjustments.length <= 0"
                    @change="onSelectAdjustment"
                />
            </b-form-group>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="addAdj.adjustment" @input="sanitize(addAdj)"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.hasAdjustmentPrice"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmAddAdjustment">
                    {{ isSubmitting ? "Menambah..." : "Tambah" }}
                </b-button>
            </div>
        </b-modal>


    </div>
</template>

<script>
import { groupByDamageType } from '@/shared/damage-types'
export default {
    name: 'modal-input-barang-masuk-external',
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            input: {
                year: null,
                isHandphone: null,
                isBatangan: 0, // Default Lengkap
                imeiSn: null,
                grade: "A", // Default A
                password: null,
                color: null,
                capital: null,
                spec: null, // Default Resmi
                priceAtPawn: null,
                adjGrade: null,
                missingAcc: [],
                nonOriAcc: [],
                description: null,
                noFakturOriginal: null,
                basePrice: null,
            },

            optGrade: ["S", "A", "B", "C", "D", "E", "X"],
            optSpec: [],
            optWarehouse: [],
            optBatangan: [
                { value: 0, text: "Lengkap" },
                { value: 1, text: "Batangan" }
            ],
            optColor: [],
            optAccessories: [],
            optYear: [],
            kinds: [],
            brands: [],
            types: [],
            years: [],
            kindId: null,
            brandId: null,
            typeId: null,
            yearId: null,
            fetch: false,
            addAdj: {
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                hasAdjustmentPrice: false,
                selectedCategoryAdjustments: [],
            },
            adjustments: [],
            optAdjustments: [],
            optCategory: [],

            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            barcodeLinkDamage: null,
            barcodeLink: null,
            isGold: false,


        }
    },
    methods: {
        async init() {
            this.optAccessories = [];

            this.initStatus = 0

            await Promise.all([this.fetchJenisBarang(), this.fetchColor()])


            this.initStatus = 1
        },

        async fetchAdjustment() {

            await this.$axios.get("category/selection?item_kind_id=" + this.kindId.id).then(res => {
                this.optCategory = res.data.data.map(item => {
                    return {
                        value: item.id,
                        text: item.name
                    }
                })


            })
        },

        async fetchJenisBarang() {

            this.brandId = null
            this.typeId = null
            this.yearId = null
            this.input.missingAcc = []
            this.input.nonOriAcc = []

            this.fetch = true
            // only fetch data whose category is electornic
            await this.$axios.get('master/kinds?category=ELEK').then((res) => {
                this.kinds = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchMerkBarang() {

            this.brandId = null
            this.typeId = null
            this.yearId = null
            this.input.missingAcc = []
            this.input.nonOriAcc = []

            this.fetch = true
            await this.$axios.get(`master/brands/${this.kindId.id}`).then((res) => {
                this.brands = res.data.data
            }).finally(() => {
                this.fetch = false
            })

            await this.fetchAccessories()
            await this.fetchAdjustment()
        },

        async fetchTipeBarang() {
            this.fetch = true

            this.typeId = null
            this.yearId = null
            this.input.missingAcc = []
            this.input.nonOriAcc = []

            await this.$axios.get(`master/types/${this.brandId.id}`).then((res) => {
                this.types = res.data.data
            }).finally(() => {
                this.fetch = false
            })


        },

        async fetchTahunBarang(e) {

            this.input.basePrice = e.base_price;

            this.yearId = null

            this.fetch = true
            await this.$axios.get(`master/years/${this.typeId.id}`).then((res) => {
                this.years = res.data.data
            })

            await this.$axios.get(`master/type-price/${this.typeId.id}`).then((res) => {
                this.optSpec = res.data.data
            })

            this.fetch = false
        },


        async fetchSpec() {
            this.fetch = true
            await this.$axios.get('master/spec/selection').then((res) => {
                this.optSpec = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchAccessories() {
            this.fetch = true
            await this.$axios.get(`master/accessory-option?filterKind=${this.kindId.id}`).then((res) => {
                this.optAccessories = res.data.data.items
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchColor() {
            this.fetch = true
            await this.$axios.get('master/color/selection').then((res) => {
                this.optColor = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        promptSubmit() {
            this.$bvModal.show("m-confirm-submit")


            this.postInsertExternal()
        },

        postInsertExternal() {

            if (this.input.capital == null || this.input.capital == "" || this.input.capital == 0) {
                this.$helper.toastError(this, "Modal tidak boleh kosong")
                return
            }

            if (this.input.color == null || this.input.color == "" || this.input.color == 0) {
                this.$helper.toastError(this, "Warna tidak boleh kosong")
                return
            }

            const payload = {
                "type_id": this.typeId ? this.typeId.id : null,
                "year": this.yearId ? this.yearId.year : null,
                "is_handphone": this.kindId ? this.kindId.id == 1 : null,
                "is_batangan_pgi": this.isGold ? 0 : this.input.isBatangan, // force set when barang masuk external isGold
                "imei_sn": this.isGold ? "-" : this.input.imeiSn,
                "grade": this.isGold ? "A" : this.input.grade,
                "password": this.input.password,
                "capital": this.$helper.toNumber(this.input.capital),
                "price_at_pawn": this.$helper.toNumber(this.input.priceAtPawn),
                "item_spec_id": this.isGold ? 2 : this.input.spec,
                "colorId": this.isGold ? 11 : this.input.color,
                "adjGrade": this.input.adjGrade ? this.$helper.toNumber(this.input.adjGrade) : null,
                "missing_accessories": this.input.missingAcc,
                "not_ori_accessories": this.input.nonOriAcc,
                "description": this.input.description,
                "no_faktur_original": this.input.noFakturOriginal,
                "adjInvoice": this.adjustments.map(item => {
                    return {
                        "name": item.name,
                        "adjustment": this.$helper.toNumber(item.adjustment),
                        "adjustment_id": item.adjustmentId
                    }
                })
            }

            this.isSubmitting = true
            this.$axios.post('delivery/insert-external', payload).then((res) => {
                this.$bvModal.hide("m-input-barang-masuk-external")
                this.$emit("refresh")
                this.clearInput()

                this.barcodeLink = res.data.data.link
                this.barcodeLinkDamage = res.data.data.linkDamage
                this.$bvModal.show('m-barcode')

            }).catch(error => {
                // error message validate laravel
                if (error.response.status == 422) {
                    this.$helper.toastError(this, error.response.data.message)
                }
                else {
                    this.$helper.parseError(this, error)
                }
            })
                .finally(() => this.isSubmitting = false)
        },

        clearInput() {
            this.input = {
                year: null,
                isHandphone: null,
                isBatangan: null,
                imeiSn: null,
                grade: null,
                password: null,
                color: null,
                capital: null,
                priceAtPawn: null,
                adjGrade: null,
                missingAcc: [],
                nonOriAcc: [],
            }

            this.kindId = null
            this.brandId = null
            this.typeId = null
            this.yearId = null
            this.adjustments = []

        },

        getBarcodeLink() {
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
        },

        finishApproval() {
            this.$bvModal.hide('m-barcode')
            this.$emit("approved")
        },

        sanitizeCapital() {
            let cleaned = String(this.input.capital).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.capital = res
        },

        sanitizePriceAtPawn() {
            let cleaned = String(this.input.priceAtPawn).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.priceAtPawn = res
        },

        sanitizeAdjGrade() {
            let cleaned = String(this.input.adjGrade).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.adjGrade = res
        },

        onChangeRowCategory(index) {
            this.adjustments[index].name = ""
            this.adjustments[index].adjustmentSelect = null
            this.adjustments[index].optAdjustments = []
            if (!this.$helper.isBlank(this.adjustments[index].category)) {
                let param = "?item_kind_id=" + this.kindId.id
                param += "&category_id=" + this.adjustments[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.adjustments[index].optAdjustments = groupByDamageType(res.data.data.map(item => {
                        return {
                            value: {
                                id: item.id,
                                name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentages: item.adjustment_percentages,
                            },
                            text: item.name,
                            damage_type: item.damage_type
                        }
                    }), o => o.damage_type)

                    this.isSubmitting = false
                })
            }
        },

        sanitize(item) {
            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res
        },

        addRow() {
            this.adjustments.push({ name: "", category: "", adjustmentSelect: "", adjustment: "", adjustmentPercentage: "", optAdjustments: [] })
        },

        deleteRow(index) {
            this.adjustments.splice(index, 1)
        },

        onSelectAdjustment(e) {
            const selected = this.addAdj.selectedCategoryAdjustments.find(
                item => item.id === e
            ).adjustment_percentages;

            if (!selected) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            const adjustmentObj = selected.find(
                range => this.input.basePrice >= range.from && this.input.basePrice <= range.to
            );

            const adjustmentPrice = adjustmentObj ? adjustmentObj.nominal : 0;

            if (adjustmentPrice === 0) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            let cleaned = String(adjustmentPrice).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")

            this.addAdj.adjustment = res;
            this.addAdj.hasAdjustmentPrice = true;
        },
        openModalAdjustment() {
            this.$bvModal.show("m-add-adjustment")
        },
        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            this.addAdj.hasAdjustmentPrice = false
            this.addAdj.adjustment = ""
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.kindId.id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = groupByDamageType(res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name,
                            damage_type: item.damage_type
                        }
                    }), o => o.damage_type)

                    this.addAdj.selectedCategoryAdjustments = res.data.data;
                    this.isSubmitting = false
                })
            }
        },
        confirmAddAdjustment() {

            if (this.$helper.isBlank(this.addAdj.category)) {
                return this.$helper.toastError(this, "Mohon mengisi kategori kerusakan!")
            }

            if (this.$helper.isBlank(this.addAdj.name)) {
                return this.$helper.toastError(this, "Mohon mengisi keterangan kerusakan!")
            }

            if (this.$helper.isBlank(this.addAdj.adjustment) || this.addAdj.adjustment == "0") {
                return this.$helper.toastError(this, "Mohon mengisi adjustment harga!")
            }

            this.adjustments.push({
               name: (function() {
                   const adj = this.addAdj.optAdjustments.flatMap(g => g.options).find(adj => adj.value === this.addAdj.name);
                   return adj ? adj.text : "";
               }).call(this),
               category: (function() {
                   const cat = this.optCategory.find(cat => cat.value === this.addAdj.category);
                   return cat ? cat.text : "";
               }).call(this),
               adjustment: this.addAdj.adjustment,
               adjustmentId: this.addAdj.name,
            });

            this.addAdj = {
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                hasAdjustmentPrice: false,
                selectedCategoryAdjustments: [],
            };

            this.$bvModal.hide("m-add-adjustment");
        }
    },
    mounted() {
        // this.init()
    },
    computed: {
        hasYear() {
            if (!this.typeId) return null;
            return this.typeId.has_year;
        }
    },
    watch: {
        kindId(newVal) {
            this.isGold = newVal.category === "EMAS";
        },
    }
}
</script>
